<i18n src="./resources/locales.json"></i18n>
<template>
  <v-select
    v-if="isSmtpEnabled"
    id="assigned-emails"
    class="flex-grow-1 mx-2 signature-edit-item"
    chips
    dense
    multiple
    :label="$t('assignedEmails')"
    :items="formattedItems"
    :value="value"
    @change="onEmailsChange"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @click="selectAll">
        <v-list-item-action>
          <v-icon :color="value.length > 0 ? 'primary' : ''">
            {{ selectAllIcon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('selectAll') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'EcsAssignedEmails',
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    isSmtpEnabled: {
      type: Boolean,
      required: true
    },
    onValueChange: {
      type: Function,
      required: true
    }
  },
  computed: {
    formattedItems() {
      return this.items.map(item => ({
        text: `${item.email} (${item.businessProcessName})`,
        value: item.email
      }));
    },
    selectAllIcon() {
      if (this.value.length === this.items.length) {
        return 'mdi-close-box';
      }
      if (this.value.length === 0) {
        return 'mdi-checkbox-blank-outline';
      }
      return 'mdi-minus-box';
    }
  },
  methods: {
    onEmailsChange(value) {
      const result = this.items.filter(item => value.includes(item.email));
      this.onValueChange(result);
    },
    selectAll() {
      const emails = [];
      if (this.value.length !== this.items.length) {
        this.items.forEach(item => emails.push(item));
      }
      this.onValueChange(emails);
    }
  }
};
</script>

<style>
.signature-edit-item .v-chip {
  margin: 4px 0px !important;
}
</style>
